import React, { useEffect } from "react";
import "./PolicyPage.css"; // Reuse the same CSS as the PolicyPage for consistency

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Điều khoản sử dụng và chính sách cookie | XEVF.VN";
  }, []);

  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>ĐIỀU KHOẢN SỬ DỤNG VÀ CHÍNH SÁCH COOKIE</h1>
        <p className="policy-meta">
          <strong>Áp dụng cho website:</strong> <a href="http://www.xevf.vn" style={{color: 'var(--primary-color)'}}>www.xevf.vn</a><br />
          <strong>Cập nhật lần cuối:</strong> 15/07/2026
        </p>

        <div className="policy-content">
          <h2>1. Phạm vi áp dụng</h2>
          <p>
            Điều khoản sử dụng và Chính sách Cookie này quy định các điều kiện khi người dùng truy cập và sử dụng website <strong><a href="http://www.xevf.vn" style={{color: '#fff'}}>www.xevf.vn</a></strong>. Việc truy cập hoặc sử dụng website đồng nghĩa với việc người dùng đã đọc, hiểu và đồng ý tuân thủ các nội dung được quy định trong tài liệu này.
          </p>

          <h2>2. Giới thiệu về website</h2>
          <p>
            <a href="http://www.xevf.vn" style={{color: '#fff'}}>www.xevf.vn</a> là website cung cấp thông tin tham khảo về các dòng xe điện VinFast, bao gồm:
          </p>
          <ul>
            <li>Giới thiệu thông tin các mẫu xe;</li>
            <li>Thông số kỹ thuật;</li>
            <li>So sánh các mẫu xe;</li>
            <li>Bảng giá tham khảo;</li>
            <li>Tiếp nhận yêu cầu liên hệ từ người dùng.</li>
          </ul>
          <p>
            Website được xây dựng nhằm hỗ trợ người dùng tra cứu và tham khảo thông tin trước khi đưa ra quyết định mua xe.
          </p>
          <p>
            Website <strong>không bán xe</strong>, <strong>không nhận đặt cọc</strong>, <strong>không thực hiện thanh toán trực tuyến</strong> và <strong>không phải là website chính thức của VinFast</strong>.
          </p>
          <p>
            Khi người dùng lựa chọn đặt cọc hoặc mua xe, website sẽ chuyển hướng đến website chính thức của VinFast để thực hiện giao dịch.
          </p>

          <h2>3. Chấp nhận điều khoản sử dụng</h2>
          <p>Khi truy cập website, người dùng cam kết:</p>
          <ul>
            <li>Tuân thủ các quy định của pháp luật Việt Nam.</li>
            <li>Không sử dụng website cho các mục đích trái pháp luật.</li>
            <li>Không thực hiện các hành vi gây ảnh hưởng đến hoạt động bình thường của website.</li>
            <li>Không can thiệp, phá hoại hoặc cố gắng truy cập trái phép vào hệ thống của website.</li>
          </ul>

          <h2>4. Nội dung trên website</h2>
          <p>
            Thông tin trên website được tổng hợp từ các nguồn đáng tin cậy và được cập nhật thường xuyên.
          </p>
          <p>
            Tuy nhiên, do thông số kỹ thuật, giá bán, chương trình ưu đãi hoặc chính sách bán hàng của VinFast có thể thay đổi theo từng thời điểm nên website không đảm bảo mọi thông tin luôn chính xác tuyệt đối tại mọi thời điểm.
          </p>
          <p>
            Người dùng nên kiểm tra thông tin mới nhất trên website chính thức của VinFast hoặc liên hệ đại lý VinFast trước khi đưa ra quyết định mua xe.
          </p>

          <h2>5. Quyền sở hữu trí tuệ</h2>
          <p>
            Toàn bộ giao diện, bố cục, nội dung, hình ảnh, biểu tượng, mã nguồn (trừ những nội dung thuộc quyền sở hữu của bên thứ ba), tài liệu và các thành phần khác trên website thuộc quyền quản lý hoặc quyền sử dụng hợp pháp của chủ sở hữu website theo quy định của pháp luật.
          </p>
          <p>
            Người dùng không được sao chép, chỉnh sửa, phát hành hoặc sử dụng lại các nội dung trên website cho mục đích thương mại nếu chưa được sự đồng ý của chủ sở hữu hoặc chủ thể có quyền liên quan.
          </p>

          <h2>6. Liên kết đến website của bên thứ ba</h2>
          <p>
            Website có thể chứa liên kết đến website chính thức của VinFast hoặc các website khác nhằm cung cấp thêm thông tin cho người dùng.
          </p>
          <p>
            Sau khi rời khỏi <a href="http://www.xevf.vn" style={{color: '#fff'}}>www.xevf.vn</a>, người dùng sẽ chịu sự điều chỉnh bởi điều khoản và chính sách của website mà mình truy cập. Chủ sở hữu website không chịu trách nhiệm đối với nội dung hoặc hoạt động của các website bên thứ ba.
          </p>

          <h2>7. Miễn trừ trách nhiệm</h2>
          <p>Chủ sở hữu website không chịu trách nhiệm đối với các thiệt hại phát sinh từ:</p>
          <ul>
            <li>Việc người dùng sử dụng thông tin trên website để đưa ra quyết định mà không kiểm chứng với nguồn chính thức.</li>
            <li>Việc website tạm thời gián đoạn do bảo trì, sự cố kỹ thuật hoặc các nguyên nhân ngoài khả năng kiểm soát.</li>
            <li>Các thay đổi về thông số kỹ thuật, giá bán, chương trình khuyến mại hoặc chính sách bán hàng của VinFast sau thời điểm thông tin được cập nhật trên website.</li>
          </ul>
          <p>
            Website chỉ cung cấp thông tin tham khảo và không thay thế cho các thông báo chính thức từ VinFast.
          </p>

          <h2>8. Chính sách Cookie</h2>
          <h3>8.1 Cookie là gì?</h3>
          <p>
            Cookie là các tệp dữ liệu nhỏ được trình duyệt lưu trên thiết bị của người dùng nhằm hỗ trợ hoạt động của website.
          </p>

          <h3>8.2 Cookie được sử dụng trên website</h3>
          <p>
            <a href="http://www.xevf.vn" style={{color: '#fff'}}>www.xevf.vn</a> chỉ sử dụng <strong>cookie kỹ thuật cần thiết</strong> để đảm bảo website hoạt động ổn định.
          </p>
          <p>Các cookie này có thể được sử dụng để:</p>
          <ul>
            <li>duy trì hoạt động của website;</li>
            <li>ghi nhớ một số thiết lập hiển thị của trình duyệt trong phiên truy cập;</li>
            <li>nâng cao khả năng tương thích và hiệu suất hoạt động.</li>
          </ul>
          <p>
            Website <strong>không sử dụng cookie để theo dõi người dùng</strong>, <strong>không phân tích hành vi truy cập</strong>, <strong>không phục vụ quảng cáo</strong> và <strong>không xây dựng hồ sơ người dùng</strong>.
          </p>

          <h3>8.3 Quản lý Cookie</h3>
          <p>
            Người dùng có thể xóa hoặc chặn cookie thông qua phần cài đặt của trình duyệt.
          </p>
          <p>
            Việc vô hiệu hóa cookie kỹ thuật có thể khiến một số chức năng của website hoạt động không ổn định hoặc không hiển thị đúng.
          </p>

          <h2>9. Sửa đổi điều khoản</h2>
          <p>
            Chủ sở hữu website có quyền sửa đổi hoặc cập nhật Điều khoản sử dụng và Chính sách Cookie để phù hợp với quy định của pháp luật hoặc sự thay đổi trong hoạt động của website.
          </p>
          <p>
            Phiên bản mới nhất sẽ được đăng tải trên website và có hiệu lực kể từ thời điểm công bố.
          </p>

          <h2>10. Luật áp dụng</h2>
          <p>
            Điều khoản sử dụng và Chính sách Cookie này được điều chỉnh và giải thích theo pháp luật nước Cộng hòa xã hội chủ nghĩa Việt Nam.
          </p>
          <p>
            Mọi tranh chấp phát sinh liên quan đến việc sử dụng website sẽ được ưu tiên giải quyết thông qua thương lượng. Trường hợp không đạt được thỏa thuận, tranh chấp sẽ được giải quyết theo quy định của pháp luật Việt Nam.
          </p>

          <h2>11. Thông tin liên hệ</h2>
          <p>Nếu có câu hỏi hoặc góp ý liên quan đến Điều khoản sử dụng và Chính sách Cookie, vui lòng liên hệ:</p>
          <p><strong>Chủ sở hữu website <a href="http://www.xevf.vn" style={{color: '#fff'}}>www.xevf.vn</a></strong></p>
          <ul>
            <li>Email: <strong><a href="mailto:thanhtrung86nd@gmail.com" style={{color: '#fff'}}>thanhtrung86nd@gmail.com</a></strong></li>
            <li>Điện thoại: <strong>0984472080</strong></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
